import { useEffect, useState } from 'react';
import api from '../../services/api';

const ERREUR = "Les affaires n'ont pas pu être chargées. Réessayez dans un instant.";

/**
 * Une page de la vitrine des bonnes affaires (GET /api/listings/affaires).
 * Garde les données précédentes pendant un rechargement : la grille ne se vide
 * pas à chaque pilule touchée.
 */
export default function useAffaires(params) {
  const [etat, setEtat] = useState({ donnees: null, chargement: true, erreur: '' });
  const cle = JSON.stringify(params);

  useEffect(() => {
    const controle = new AbortController();
    const propres = Object.fromEntries(
      Object.entries(JSON.parse(cle)).filter(([, v]) => v !== undefined && v !== null && v !== ''),
    );
    setEtat((e) => ({ ...e, chargement: true, erreur: '' }));
    api.get('/api/listings/affaires', { params: propres, signal: controle.signal })
      .then((res) => setEtat({ donnees: res.data, chargement: false, erreur: '' }))
      .catch(() => {
        if (controle.signal.aborted) return;
        setEtat((e) => ({ ...e, chargement: false, erreur: ERREUR }));
      });
    return () => controle.abort();
  }, [cle]);

  return etat;
}
